import { useRef } from 'react';
export function useDragScroll({ scrollRef }) {
    const isDraggingRef = useRef(false);
    const startScrollLeftRef = useRef(0);
    const startXRef = useRef(0);
    const lastXRef = useRef(0);
    const lastDeltaRef = useRef(0);
    const getClientX = (event) => {
        if ('touches' in event && event.touches.length > 0) {
            return event.touches[0].clientX; // for TouchEvent
        }
        else if ('clientX' in event) {
            return event.clientX; // for MouseEvent
        }
        return 0;
    };
    const onPointerDown = (event) => {
        if (!scrollRef.current)
            return;
        isDraggingRef.current = true;
        startXRef.current = getClientX(event);
        startScrollLeftRef.current = scrollRef.current.scrollLeft;
        lastXRef.current = getClientX(event);
        lastDeltaRef.current = 0;
    };
    const onPointerMove = (event) => {
        if (!isDraggingRef.current || !scrollRef.current)
            return;
        const clientX = getClientX(event);
        const diff = clientX - startXRef.current;
        scrollRef.current.scrollLeft = startScrollLeftRef.current - diff;
        lastDeltaRef.current += Math.abs(clientX - lastXRef.current);
        lastXRef.current = clientX;
    };
    const onPointerUp = (event) => {
        event.preventDefault();
        if (!isDraggingRef.current || !scrollRef.current)
            return;
        isDraggingRef.current = false;
        return {
            delta: lastDeltaRef.current,
            positionX: lastXRef.current,
        };
    };
    return { onPointerDown, onPointerMove, onPointerUp };
}
